import './index.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as OffcanvasMenu from '../assets-base/assets-src/js/Spinao/OffcanvasMenu';
//import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import '../assets-base/assets-src/js/Bootstrap/dropdown';
import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/alert';
//import '../assets-base/assets-src/js/Bootstrap/button';
import '../assets-base/assets-src/js/Bootstrap/carousel';
import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/modal';
//import '../assets-base/assets-src/js/Bootstrap/offcanvas';
//import '../assets-base/assets-src/js/Bootstrap/popover';
//import '../assets-base/assets-src/js/Bootstrap/scrollspy';
//import '../assets-base/assets-src/js/Bootstrap/tab';
//import '../assets-base/assets-src/js/Bootstrap/toast';
//import '../assets-base/assets-src/js/Bootstrap/tooltip';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as ScrollReveal from '../assets-base/assets-src/js/Spinao/ScrollReveal';
import * as EndlessList from '../assets-base/assets-src/js/Spinao/EndlessList';
import * as HeaderCarousel from './js/HeaderCarousel';

import '../assets-base/assets-src/js/Spinao/Masonry';
import '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import "../assets-base/assets-src/js/Spinao/CookieConsent";



document.addEventListener("DOMContentLoaded", function() {
    EndlessList.applyTo('[data-endless-list]');

    Lightgallery.applyTo('[data-lightgallery="area"]', {
        selector:'[data-lightgallery="image"]',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    OffcanvasMenu.initialize();
    //StickyTopMenu.initialize();

    NetteAjaxForm.initialize('form[data-ajax]');

    GoogleMaps.initialize();


    UnifyHeight.applyDataAttribute();

    ScrollReveal.initialize();

    HeaderCarousel.initialize('.header-carousel', { interval: 5000, transitionDuration: 800 });

    // Services slider - automatické posouvání
    const servicesSlider = document.querySelector('.services-slider');
    if (servicesSlider) {
        let autoScrollInterval;
        let isUserInteracting = false;

        const startAutoScroll = () => {
            autoScrollInterval = setInterval(() => {
                if (!isUserInteracting) {
                    const cardWidth = servicesSlider.querySelector('.service-card').offsetWidth;
                    const gap = 16; // 1rem
                    const maxScroll = servicesSlider.scrollWidth - servicesSlider.clientWidth;

                    if (servicesSlider.scrollLeft >= maxScroll - 10) {
                        servicesSlider.scrollTo({ left: 0, behavior: 'smooth' });
                    } else {
                        servicesSlider.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
                    }
                }
            }, 4000);
        };

        // Zastavit při interakci uživatele
        servicesSlider.addEventListener('mouseenter', () => { isUserInteracting = true; });
        servicesSlider.addEventListener('mouseleave', () => { isUserInteracting = false; });
        servicesSlider.addEventListener('touchstart', () => { isUserInteracting = true; });
        servicesSlider.addEventListener('touchend', () => {
            setTimeout(() => { isUserInteracting = false; }, 3000);
        });

        // Spustit auto-scroll pouze na menších breakpointech
        if (window.innerWidth < 1200) {
            startAutoScroll();
        }

        window.addEventListener('resize', () => {
            clearInterval(autoScrollInterval);
            if (window.innerWidth < 1200) {
                startAutoScroll();
            }
        });
    }

    // Stats counter animace
    const statsSection = document.querySelector('.about-stats');
    if (statsSection) {
        const counters = statsSection.querySelectorAll('.about-stat-number');

        const animateCounter = (el, target, suffix, duration) => {
            const start = performance.now();
            const tick = (now) => {
                const progress = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
                el.textContent = Math.round(eased * target) + suffix;
                if (progress < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        };

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                counters.forEach(counter => {
                    const text = counter.textContent.trim();
                    const target = parseInt(text, 10);
                    const suffix = text.replace(/[0-9]/g, '');
                    animateCounter(counter, target, suffix, 3000);
                });
                observer.disconnect();
            }
        }, { threshold: 0.3 });

        observer.observe(statsSection);
    }

    // Parallax efekt pro bg-headline-block
    // Bez JS zůstane CSS fixed attachment jako fallback
    const parallaxBgs = document.querySelectorAll('.bg-headline-block .bg-items');
    if (parallaxBgs.length > 0 && window.innerWidth >= 768) {
        parallaxBgs.forEach(bg => {
            bg.classList.add('js-parallax-ready');
        });

        const updateParallax = () => {
            const scrollY = window.scrollY;
            parallaxBgs.forEach(bg => {
                // Parallax rychlost 0.5 = obrázek se pohybuje poloviční rychlostí než scroll
                const yOffset = scrollY * 0.5;
                bg.style.backgroundPosition = `center calc(50% + ${yOffset}px)`;
            });
        };

        window.addEventListener('scroll', updateParallax, { passive: true });
        updateParallax(); // Inicializace
    }
});
